











































































Vue.use require('element-ui/lib/progress').default

module.exports =
  name: 'virtual_edit'
  components:
    balance:                    require('components/inside/elements/balance.vue').default
    goal_info:                  require('./goal_info.vue').default
    destroy_confirmation_modal: require('components/inside/pages/accounts/destroy_confirmation.vue').default
    offline_bar:                require('components/inside/offline_bar.vue').default
  data: ->
    form: _.clone(@$store.state.ui.virtuals.edited)
    rules:
      name: [
        { required: true, message: @$t('name_is_required') }
      ]
      aim: [
        { required: true, message: @$t('more_than_0') }
      ]
      balance: [
        { required: true, message: @$t('balance_is_required') },
        { type: 'number', message: @$t('balance_is_number') }
      ]
    formValid: false
    ready_to_delete: false

  computed:
    edited:     -> @$store.state.ui.virtuals.edited
    categories: -> @$store.state.user.virtual_categories
    currencies: -> @$store.state.user.currencies
    goal_finish_date_f: -> hm_date.format(@form.goal_finish_date)
    virtual_type: ->
      return @$t('Fund') if @form.isFund()
      return @$t('Goal') if @form.isGoal()
      return ''
    virtual_transactions_length: -> @$store.state.user.transactions.filter((tr) => tr.isRelatedToVirtual(@edited.id)).length
    aim_label: ->
      if @form.isFund() then @$t('Fund size') else @$t('Needed to save')
  watch:
    edited: ->
      @ready_to_delete = false
      @form = _.clone(@$store.state.ui.virtuals.edited)
      if @form?.id && !HM.is_mobile
        @$nextTick => $(@$el).find("[name='balance']").focus()
  methods:
    close: -> @$store.commit 'VIRTUALS/EDIT', null
    save: (form) ->
      @$store.dispatch 'saveVirtual', form
      HM.track("virtual-create", { subtype: form.fSubtype() }) if form.isNew()
      HM.track("virtual-update", { subtype: form.fSubtype() }) if !form.isNew()
      @close()
      @$message.success @$t('Done')
    destroy: (form) ->
      @$store.dispatch 'destroyVirtual', form
      HM.track("virtual-destroy", { subtype: form.fSubtype() })
      @$message.success @$t('Done')
      @close()

    validateForm: ->
      if @$refs.form
        @$refs.form.validate (valid) =>
          @formValid = valid

    hide: ->
      @form.hidden = true
      @ready_to_delete = false
  mounted: ->
    @$watch 'form', @validateForm, { immediate: true, deep: true }
